import React, { Fragment, useEffect, useState, useContext } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { ObjModal } from '../../../contexts';


import '../modals.css';

const ExtraFields = ( { close, extra, nextStep } ) => {
    const [ tmp, setTmp ] = useState( {} );
    const [ loaded, setLoaded ] = useState( false );
    const { setExtraFields, extraReady } = useContext( ObjModal );
    

    const handleChange = ( field, value ) => {
        setTmp( prev => {
            return {
                ...prev,
                [field]: value
            }
        } );
    }

    const next = ( e ) => {
        e.preventDefault();
        setExtraFields( tmp );
    }

    
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '550px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    useEffect( () => {
        if ( extra ) {
            const init = extra.reduce( ( acc, e ) => {
                acc[e.field] = '';
                return acc;
            }, {} );
            setTmp( init );
            setLoaded( true );
        }
    }, [ extra ] );

    useEffect( () => {
        if ( extraReady ) {
            nextStep();
            setTmp( {} );
            close();
        }
    }, [ extraReady, close, nextStep ] );

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>This Next Step Requires Some Extra Info...</Col>
                </Row>
                {
                    ( !loaded ) ? (
                        <div style={ { height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' } }>
                            <Spinner animation='border' />
                        </div>
                    ) : (
                        extra.map( ( e, idx ) => (
                            <Row className='py-2' key={`extra-${idx}`}>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>{e.label}</Form.Label>
                                        <Form.Control className='tf-modal-text-input' type="text" name={e.field} placeholder="Enter a value" value={tmp[e.field]} onChange={ ( ev ) => handleChange( e.field, ev.target.value ) } />
                                    </Form.Group>
                                </Col>
                            </Row>
                        ) )
                    )
                }
                <Row className='py-3'>
                    <Col xs='auto'>
                        <Button size='sm' variant='outline-primary' onClick={ ( e ) => next( e ) }>Continue</Button>
                    </Col>
                    <Col xs='auto'>
                        <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                    </Col>
                </Row>
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    // aid: state.user.aid,
    uid: state.user.email,
    // cid: state.contacts.currentId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( ExtraFields );